(function(){
  function reveal(){
    var els=document.querySelectorAll('.hv-rv:not(.is-in)');
    if(!('IntersectionObserver' in window)){for(var i=0;i<els.length;i++)els[i].classList.add('is-in');return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
    for(var j=0;j<els.length;j++)io.observe(els[j]);
  }
  function countdown(){
    var cds=document.querySelectorAll('[data-hv-countdown]');
    for(var i=0;i<cds.length;i++){(function(el){
      if(el.dataset.ready)return;el.dataset.ready='1';
      var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]');
      function tick(){var n=new Date(),e=new Date(n);e.setHours(23,59,59,999);var d=Math.max(0,Math.floor((e-n)/1000));
        h.textContent=String(Math.floor(d/3600)).padStart(2,'0');m.textContent=String(Math.floor(d%3600/60)).padStart(2,'0');s.textContent=String(d%60).padStart(2,'0');}
      tick();setInterval(tick,1000);
    })(cds[i]);}
  }
  function boot(){reveal();countdown();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();